import React from "react";
import { connect } from "react-redux";

import ReactTable from "react-table";
import SweetAlert from "react-bootstrap-sweetalert";

import {
    getSolicitudDetalle, consultarGuia,
    limpiarDetalle, limpiarGuia, closeMessages
} from "../../../store/actions/autorizarActions";
import { logout } from "../../../store/actions/authActions";
import { marcarVistas } from "../../../store/actions/notificacionesActions";

import IntentosTab from "./IntentosTab.js";
import MapaComparativo from "./MapaComparativo.js";
import {
    Transition, chipEstatus, chipEntrega, chipTipo, chipIntento,
    coordenadasValidas, renglonDato, galeria, textosTabla
} from "./comunes.js";
import ImagenAuth from "components/ImagenAuth/ImagenAuth.js";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import NavPills from "components/NavPills/NavPills.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Spinner from "components/Spinner/Spinner.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from '@material-ui/icons/Visibility';

import stylesSweetAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);
const useStylesAlert = makeStyles(stylesSweetAlert);

// Modulo "Intentos de entrega" (ruta /admin/intentos-entrega, todos los usuarios):
//   1. Intentos de entrega (IntentosTab, por defecto): tablero de solo lectura de los
//      intentos que registran los choferes; cada sucursal ve los suyos, matriz todos.
//   2. Consulta de guia: maestra + entregas EAD + intentos + seguimiento y, como parte
//      del historial de la guia, las solicitudes de devolucion de la app vieja (matriz
//      puede abrir su detalle comparativo). Logistica ya no autoriza ni rechaza nada:
//      la devolucion la registra almacen. La antigua pestana "Solicitudes" se elimino.
function IntentosEntrega(props) {

    const classes = useStyles();
    const classesAlert = useStylesAlert();

    const [esmatriz] = React.useState(localStorage.getItem("esmatriz") === "s");

    // modal de detalle de una solicitud historica (desde Consulta de guia, solo matriz)
    const [modalOpen, setModalOpen] = React.useState(false);

    // tab Consulta de guia
    const [guiaConsulta, setGuiaConsulta] = React.useState("");
    const [guiaConsultada, setGuiaConsultada] = React.useState("");
    const [entregaDetalle, setEntregaDetalle] = React.useState(null);
    const [entregaModalOpen, setEntregaModalOpen] = React.useState(false);

    const [loading, setLoading] = React.useState(false);

    // entrar al modulo apaga los avisos "no vistos" de la campanita
    React.useEffect(() => {
        props.marcarVistas();
    }, []);

    // push (FCM Web) con la vista abierta: se apagan los "no vistos" (la recarga del
    // tablero de intentos la atiende IntentosTab)
    React.useEffect(() => {
        if (props.ultimoAviso == null) { return; }
        props.marcarVistas();
    }, [props.ultimoAviso]);

    React.useEffect(() => {
        if (props.guiaData != null) { setLoading(false); }
    }, [props.guiaData]);

    // ante cualquier error apagar el spinner
    React.useEffect(() => {
        if (props.MensajeError != null) { setLoading(false); }
    }, [props.MensajeError]);

    // ─── Modal de detalle de solicitud (solo lectura) ────────────────────────

    const abrirDetalle = (id) => {
        props.limpiarDetalle();
        setModalOpen(true);
        props.getSolicitudDetalle(id);
    };

    const cerrarModal = () => {
        setModalOpen(false);
        props.limpiarDetalle();
    };

    const detalle = props.detalleData == null ? null : props.detalleData.resultado;

    let puntosComparativo = [];
    if (detalle != null) {
        // DIRECTA no tiene entrega previa: solo el punto de la solicitud (los ant_*
        // llegan vacios y coordenadasValidas ya daria null; el guard lo hace explicito)
        if (detalle.tipo !== "DIRECTA") {
            const puntoAnterior = coordenadasValidas(detalle.ant_lat, detalle.ant_lon);
            if (puntoAnterior != null) {
                puntosComparativo.push({ ...puntoAnterior, titulo: "Entrega original" });
            }
        }
        const puntoNuevo = coordenadasValidas(detalle.lat, detalle.lon);
        if (puntoNuevo != null) {
            puntosComparativo.push({ ...puntoNuevo, titulo: "Devolución solicitada", icono: "mark" });
        }
    }

    // pie del detalle: como es historico ya no hay botones Autorizar/Rechazar; una
    // PENDIENTE heredada (no deberia quedar ninguna tras el cutover) solo se informa
    let pieDetalle = null;
    if (detalle != null) {
        if (detalle.estatus === "PENDIENTE") {
            pieDetalle = (
                <p style={{ textAlign: "center", color: "#e65100", fontWeight: 600, marginTop: 10 }}>
                    Solicitud pendiente: las devoluciones ya no se autorizan desde este módulo; la guía la devuelve almacén desde la app.
                </p>
            );
        } else {
            pieDetalle = (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                    <p>
                        {chipEstatus(detalle.estatus)}
                        {" "}por <strong>{detalle.nombre_autorizo}</strong> el {detalle.fecha_resolucion}
                    </p>
                    {detalle.comentario_autorizo ? renglonDato("Comentario", detalle.comentario_autorizo) : null}
                </div>
            );
        }
    }

    const modalDetalle = (
        <Dialog
            open={modalOpen} TransitionComponent={Transition} keepMounted onClose={cerrarModal} maxWidth="lg" fullWidth
            // el SweetAlert de error del modulo puede montarse ENCIMA de este Dialog; sin
            // esto el TrapFocus de MUI le roba el foco y no se puede cerrar
            disableEnforceFocus
        >
            <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid #f3f4f6" }}>
                <span style={{ fontSize: 16, fontWeight: 700 }}>
                    {detalle == null ? "Solicitud de devolución" : "Solicitud de devolución — Guía " + detalle.guia}
                </span>
                {detalle == null ? null : <span style={{ marginLeft: 10 }}>{chipEstatus(detalle.estatus)}</span>}
            </DialogTitle>
            <DialogContent style={{ padding: "16px 20px 20px" }}>
                {detalle == null ? (
                    <div style={{ textAlign: "center", padding: 40 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card>
                                <CardBody>
                                    <h4 className={classes.cardIconTitle} style={{ color: "#2e7d32" }}>Entrega original</h4>
                                    {detalle.tipo === "DIRECTA" ? (
                                        // solicitud DIRECTA: no hay snapshot (ant_* vacios), solo el aviso
                                        <p style={{ color: "#9e9e9e", margin: "3px 0" }}>
                                            {"Sin entrega previa — devolución solicitada desde el detalle de la guía (la guía no había sido entregada)."}
                                        </p>
                                    ) : (
                                        <React.Fragment>
                                            {renglonDato("Fecha y hora", detalle.ant_fecha)}
                                            {renglonDato("Recibió", detalle.ant_recibe)}
                                            {renglonDato("Relación", detalle.ant_relacion_recibe)}
                                            {renglonDato("Observaciones", detalle.ant_observaciones)}
                                            {renglonDato("Coordenadas", (coordenadasValidas(detalle.ant_lat, detalle.ant_lon) ? detalle.ant_lat + ", " + detalle.ant_lon : null))}
                                            <p style={{ margin: "8px 0 0" }}><strong>Fotos:</strong></p>
                                            {galeria("autorizar/solicitudes/" + detalle.id + "/foto/anterior/", detalle.fotos_anteriores, "Foto anterior")}
                                            <p style={{ margin: "8px 0 0" }}><strong>Firma:</strong></p>
                                            {(detalle.tiene_firma_anterior == 1)
                                                ? <ImagenAuth src={"autorizar/solicitudes/" + detalle.id + "/firma"} alt="Firma de la entrega original" />
                                                : <p style={{ color: "#9e9e9e", margin: "3px 0" }}>
                                                    Sin firma{detalle.ant_motivo_sin_firma ? " (" + detalle.ant_motivo_sin_firma + ")" : ""}
                                                  </p>}
                                        </React.Fragment>
                                    )}
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card>
                                <CardBody>
                                    <h4 className={classes.cardIconTitle} style={{ color: "#c62828" }}>Devolución solicitada</h4>
                                    {renglonDato("Motivo", detalle.motivo)}
                                    {renglonDato("Observaciones", detalle.observaciones)}
                                    {renglonDato("Chofer", detalle.chofer)}
                                    {renglonDato("Unidad", detalle.unidad)}
                                    {renglonDato("Folio reparto", detalle.folioreparto)}
                                    {renglonDato("Sucursal", detalle.nombresucursal)}
                                    {renglonDato("Fecha solicitud", detalle.fecha_solicitud)}
                                    {renglonDato("Coordenadas", (coordenadasValidas(detalle.lat, detalle.lon) ? detalle.lat + ", " + detalle.lon : null))}
                                    <p style={{ margin: "8px 0 0" }}><strong>Fotos:</strong></p>
                                    {galeria("autorizar/solicitudes/" + detalle.id + "/foto/nueva/", detalle.fotos_nuevas, "Foto nueva")}
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <MapaComparativo key={"solicitud-" + detalle.id} puntos={puntosComparativo} altura="350px" />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            {pieDetalle}
                        </GridItem>
                    </GridContainer>
                )}
                <div style={{ width: "100%", textAlign: "center", marginTop: 10 }}>
                    <Button color="warning" onClick={cerrarModal}>Cerrar</Button>
                </div>
            </DialogContent>
        </Dialog>
    );

    const hideAlert = () => { props.closeMessages(); };
    const handleLogOut = () => { props.closeMessages(); props.logout(); };

    let errorMessage = !props.MensajeError ? null : (
        <SweetAlert
            danger
            style={{ display: "block" }}
            title="Error!"
            onConfirm={() => props.MensajeError.indexOf("Acceso denegado") > -1 ? handleLogOut() : hideAlert()}
            onCancel={() => props.MensajeError.indexOf("Acceso denegado") > -1 ? handleLogOut() : hideAlert()}
            confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
        >
            {props.MensajeError}
        </SweetAlert>
    );

    // ─── Tab Consulta de guia ────────────────────────────────────────────────

    const buscarGuiaClick = () => {
        const vGuia = guiaConsulta.trim();
        if (vGuia === "") { return; }
        setGuiaConsultada(vGuia);
        setEntregaDetalle(null);
        setEntregaModalOpen(false);
        setLoading(true);
        props.limpiarGuia();
        props.consultarGuia(vGuia);
    };

    const abrirEntrega = (entrega) => {
        setEntregaDetalle(entrega);
        setEntregaModalOpen(true);
    };

    const cerrarEntrega = () => {
        setEntregaModalOpen(false);
    };

    const consulta = props.guiaData == null ? null : props.guiaData.resultado;

    const entregasData = consulta == null || consulta.entregas == null ? [] : (
        consulta.entregas.map((prop) => {
            return {
                id: prop.id,
                fecha: prop.fecha,
                estado: chipEntrega(prop.estado, prop.estado_texto),
                estado_texto: prop.estado_texto,
                recibe: prop.recibe,
                chofer: prop.chofer,
                unidad: prop.unidad,
                folioreparto: prop.folioreparto,
                motivodevolucion: prop.motivodevolucion,
                acciones: (
                    <div className="actions-right">
                        <Button color="success" className={classes.actionButton} onClick={() => {
                            abrirEntrega(prop);
                        }}>
                            <VisibilityIcon className={classes.icon} />
                        </Button>{" "}
                    </div>
                )
            }
        })
    );

    // intentos de entrega de la guia (mas reciente primero, tal como los manda el API)
    const intentosGuiaData = consulta == null || consulta.intentos == null ? [] : (
        consulta.intentos.map((prop) => {
            return {
                id: prop.id,
                fecha: prop.fecha,
                intento: chipIntento(prop.numero, prop.maximo),
                chofer: prop.chofer,
                unidad: prop.unidad,
                folioreparto: prop.folioreparto,
                nombresucursal: prop.nombresucursal,
                motivo: prop.motivo,
                fotos: prop.fotos,
            }
        })
    );

    const seguimientoData = consulta == null || consulta.seguimiento == null ? [] : consulta.seguimiento;

    const solicitudesGuiaData = consulta == null || consulta.solicitudes == null ? [] : (
        consulta.solicitudes.map((prop) => {
            return {
                id: prop.id,
                tipo: chipTipo(prop.tipo),
                fecha_solicitud: prop.fecha_solicitud,
                motivo: prop.motivo,
                chofer: prop.chofer,
                folioreparto: prop.folioreparto,
                estatus: chipEstatus(prop.estatus),
                nombre_autorizo: prop.nombre_autorizo,
                acciones: (
                    <div className="actions-right">
                        <Button color="success" className={classes.actionButton} onClick={() => {
                            abrirDetalle(prop.id);
                        }}>
                            <VisibilityIcon className={classes.icon} />
                        </Button>{" "}
                    </div>
                )
            }
        })
    );

    const columnasSolicitudesGuia = [
        { Header: "Id", accessor: "id", show: false },
        { Header: "Tipo", accessor: "tipo", sortable: false },
        { Header: "Fecha solicitud", accessor: "fecha_solicitud" },
        { Header: "Motivo", accessor: "motivo" },
        { Header: "Chofer", accessor: "chofer" },
        { Header: "Folio reparto", accessor: "folioreparto" },
        { Header: "Estatus", accessor: "estatus", sortable: false },
        { Header: "Autorizó", accessor: "nombre_autorizo" },
    ];
    if (esmatriz) {
        // el detalle de una solicitud sigue siendo solo matriz en el API
        columnasSolicitudesGuia.push({ Header: "Acciones", accessor: "acciones", sortable: false, filterable: false });
    }

    const cardsConsulta = consulta == null ? null : (
        <React.Fragment>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Guía {guiaConsultada}</h4>
                        {consulta.guia == null ? (
                            <p style={{ color: "#9e9e9e" }}>La guía no existe en las tablas maestras.</p>
                        ) : (
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    {renglonDato("Estado", consulta.guia.estado)}
                                    {renglonDato("Remitente", consulta.guia.remitente)}
                                    {renglonDato("Destinatario", consulta.guia.destinatario)}
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    {renglonDato("Fecha", consulta.guia.fecha)}
                                    {renglonDato("Fecha de entrega", consulta.guia.fechaentrega)}
                                </GridItem>
                            </GridContainer>
                        )}
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Entregas EAD</h4>
                        <ReactTable
                            data={entregasData}
                            filterable={false}
                            columns={[
                                { Header: "Fecha", accessor: "fecha" },
                                { Header: "Estado", accessor: "estado", sortable: false },
                                { Header: "Recibió", accessor: "recibe" },
                                { Header: "Chofer", accessor: "chofer" },
                                { Header: "Unidad", accessor: "unidad" },
                                { Header: "Folio", accessor: "folioreparto" },
                                { Header: "Motivo", accessor: "motivodevolucion" },
                                { Header: "Acciones", accessor: "acciones", sortable: false, filterable: false }
                            ]}
                            defaultPageSize={5}
                            showPaginationTop={false}
                            showPaginationBottom
                            className="-striped -highlight"
                            {...textosTabla}
                        />
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Intentos de entrega</h4>
                        <ReactTable
                            data={intentosGuiaData}
                            filterable={false}
                            columns={[
                                { Header: "Id", accessor: "id", show: false },
                                { Header: "Fecha", accessor: "fecha" },
                                { Header: "Intento", accessor: "intento", sortable: false },
                                { Header: "Repartidor", accessor: "chofer" },
                                { Header: "Unidad", accessor: "unidad" },
                                { Header: "Reparto", accessor: "folioreparto" },
                                { Header: "Sucursal", accessor: "nombresucursal" },
                                { Header: "Motivo", accessor: "motivo" },
                                { Header: "Fotos", accessor: "fotos", maxWidth: 80 }
                            ]}
                            defaultPageSize={5}
                            showPaginationTop={false}
                            showPaginationBottom
                            className="-striped -highlight"
                            {...textosTabla}
                        />
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Historial (seguimiento)</h4>
                        <ReactTable
                            data={seguimientoData}
                            filterable={false}
                            columns={[
                                { Header: "Fecha", accessor: "fecha" },
                                { Header: "Hora", accessor: "hora" },
                                { Header: "Estado", accessor: "estado" },
                                { Header: "Ubicación", accessor: "ubicacion" },
                                { Header: "Unidad", accessor: "unidad" },
                                { Header: "Usuario", accessor: "usuario" },
                                { Header: "Bitácora", accessor: "bitacora" }
                            ]}
                            defaultPageSize={10}
                            showPaginationTop={false}
                            showPaginationBottom
                            className="-striped -highlight"
                            {...textosTabla}
                        />
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Solicitudes de devolución</h4>
                        <ReactTable
                            data={solicitudesGuiaData}
                            filterable={false}
                            columns={columnasSolicitudesGuia}
                            defaultPageSize={5}
                            showPaginationTop={false}
                            showPaginationBottom
                            className="-striped -highlight"
                            {...textosTabla}
                        />
                    </CardBody>
                </Card>
            </GridItem>
        </React.Fragment>
    );

    const tabConsulta = (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Guía"
                                    formControlProps={{ fullWidth: true }}
                                    inputProps={{
                                        autoComplete: "off",
                                        value: guiaConsulta,
                                        onChange: (event) => setGuiaConsulta(event.target.value),
                                        onKeyPress: (event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                buscarGuiaClick();
                                            }
                                        },
                                    }}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                                <Button
                                    color="success"
                                    onClick={buscarGuiaClick}
                                    className={classes.registerButton}
                                >
                                    Buscar
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
            {cardsConsulta}
        </GridContainer>
    );

    // sub-detalle de una entrega EAD: galerias de fotos, firma y mini mapa
    const modalEntrega = (
        <Dialog open={entregaModalOpen} TransitionComponent={Transition} keepMounted onClose={cerrarEntrega} maxWidth="md" fullWidth>
            <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid #f3f4f6" }}>
                <span style={{ fontSize: 16, fontWeight: 700 }}>
                    {entregaDetalle == null ? "Detalle de la entrega" : "Entrega EAD — " + entregaDetalle.fecha}
                </span>
                {entregaDetalle == null ? null : <span style={{ marginLeft: 10 }}>{chipEntrega(entregaDetalle.estado, entregaDetalle.estado_texto)}</span>}
            </DialogTitle>
            <DialogContent style={{ padding: "16px 20px 20px" }}>
                {entregaDetalle == null ? null : (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            {renglonDato("Recibió", entregaDetalle.recibe)}
                            {renglonDato("Motivo devolución", entregaDetalle.motivodevolucion)}
                            {renglonDato("Observaciones", entregaDetalle.observaciones)}
                            {renglonDato("Chofer", entregaDetalle.chofer)}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            {renglonDato("Unidad", entregaDetalle.unidad)}
                            {renglonDato("Folio reparto", entregaDetalle.folioreparto)}
                            {renglonDato("Sucursal", entregaDetalle.nombresucursal || entregaDetalle.sucursal)}
                            {renglonDato("Coordenadas", (coordenadasValidas(entregaDetalle.lat, entregaDetalle.lon) ? entregaDetalle.lat + ", " + entregaDetalle.lon : null))}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <p style={{ margin: "8px 0 0" }}><strong>Fotos del acto:</strong></p>
                            {galeria("autorizar/entregas/" + entregaDetalle.id + "/foto/acto/", entregaDetalle.num_fotos, "Foto del acto")}
                            <p style={{ margin: "8px 0 0" }}><strong>Fotos diferidas (guía):</strong></p>
                            {galeria("autorizar/entregas/" + entregaDetalle.id + "/foto/guia/", entregaDetalle.num_fotos_guia, "Foto diferida")}
                            <p style={{ margin: "8px 0 0" }}><strong>Firma:</strong></p>
                            {(entregaDetalle.tiene_firma == 1)
                                ? <ImagenAuth src={"autorizar/entregas/" + entregaDetalle.id + "/firma"} alt="Firma de la entrega" />
                                : <p style={{ color: "#9e9e9e", margin: "3px 0" }}>Sin firma</p>}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <MapaComparativo
                                key={"entrega-" + entregaDetalle.id}
                                puntos={(function () {
                                    const punto = coordenadasValidas(entregaDetalle.lat, entregaDetalle.lon);
                                    return punto == null ? [] : [{ ...punto, titulo: entregaDetalle.estado_texto || "Entrega" }];
                                })()}
                                altura="300px"
                            />
                        </GridItem>
                    </GridContainer>
                )}
                <div style={{ width: "100%", textAlign: "center", marginTop: 10 }}>
                    <Button color="warning" onClick={cerrarEntrega}>Cerrar</Button>
                </div>
            </DialogContent>
        </Dialog>
    );

    const spinner = <Spinner width={"80%"} height={5} color={"black"} loading={loading} />;

    // pestanas: Intentos de entrega (por defecto) y Consulta de guia, para todos
    const tabs = [
        {
            tabButton: "Intentos de entrega",
            tabContent: <IntentosTab />
        },
        {
            tabButton: "Consulta de guía",
            tabContent: tabConsulta
        }
    ];

    return (
        <React.Fragment>
            {errorMessage}
            <div>{spinner}</div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <NavPills
                        color="success"
                        tabs={tabs}
                    />
                </GridItem>
            </GridContainer>
            {modalDetalle}
            {modalEntrega}
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        "detalleData": state.autorizar.autorizar_Detalle,
        "guiaData": state.autorizar.autorizar_Guia,
        "MensajeError": state.autorizar.autorizar_Error_Message,
        "ultimoAviso": state.notificaciones.ultimoAviso,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        "getSolicitudDetalle": (id) => dispatch(getSolicitudDetalle(id)),
        "consultarGuia": (guia) => dispatch(consultarGuia(guia)),
        "limpiarDetalle": () => dispatch(limpiarDetalle()),
        "limpiarGuia": () => dispatch(limpiarGuia()),
        "closeMessages": () => dispatch(closeMessages()),
        "logout": () => dispatch(logout()),
        "marcarVistas": () => dispatch(marcarVistas()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IntentosEntrega);
